export enum SupportStatuses {
  notSupported = 1,
  settingUp = 2,
  supported = 3
}
